import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";

import { useLogout } from "hooks/api/use-auth";
import { useClearCurrentUserCache } from "hooks/api/use-current-user";

import { Route } from "utilities/app-routes";

const Logout = () => {
  const { instance } = useMsal();
  const { mutateAsync: logoutOnServer } = useLogout();
  const clearCurrentUserCache = useClearCurrentUserCache();

  useEffect(() => {
    const currentAccount = instance.getActiveAccount();
    const doLogout = async () => {
      try {
        await logoutOnServer();
      } catch (error) {
        console.error("Server logout failed:", error);
      }

      try {
        await instance.clearCache({ account: currentAccount });
      } catch {
        // ignore
      } finally {
        window.location.replace(Route.login);
        clearCurrentUserCache();
      }
    };
    doLogout();
  }, [clearCurrentUserCache, instance, logoutOnServer]);

  return null;
};

export default Logout;
